import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import VideoHero from './components/VideoHero';
import VideoGallery from './components/VideoGallery';
import Footer from '../home/components/Footer';

export default function VideosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <VideoHero />
      <VideoGallery />
      <Footer />
    </div>
  );
}